import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { PageRequest } from "./PageRequest";

import { errorCloseImg } from "../img/errorClose.png";

import { PageInformation } from "./PageInformation";
import { PageCar } from "./PageCar";
import { PageDealer } from "./PageDealer";
import { PageCalendar } from "./PageCalendar";
import { PageAppointment } from "./PageAppointment";
import { PageMap } from "./PageMap";
import { Header } from "./components/Header";
import { Ariane } from "./components/Ariane";
import ArianeMobile from "./components/ArianeMobile";

import { scrollChange } from "../actions/scroll";
import { mobileCheck, stepDirect, errorClose } from "../actions/step";

function checkmobile() {
  var check = false;
  (function(a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
        a
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4)
      )
    )
      check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
}

const activeScroll = {
  opacity: 1
};

const lastPage = {
  height: "100%",
  top: "0px"
};

class Module extends Component {
  constructor(props) {
    super(props);
    this.handleScroll = this.handleScroll.bind(this);
  }
  componentDidMount() {
    if (this.props.restIntel.intel.dealers === null) {
      this.props.stepDirect(0, "/");
    }
    this.refs.scrollDiv.addEventListener("scroll", this.handleScroll);
  }
  componentWillUnmount() {
    this.refs.scrollDiv.removeEventListener("scroll", this.handleScroll);
  }
  handleScroll(event) {
    this.props.scrollChange(this.refs.scrollDiv.scrollTop);
  }
  componentDidUpdate() {
    if (checkmobile() && this.props.step.desktop) {
      this.props.mobileCheck();
    }
    if (this.props.step.scrollTop === 0) {
        this.refs.scrollDiv.scrollTop = 0;
    }
  }
  render() {
    return (
      <div>
        {this.props.step.errorState ? (
          <div className="error">
            <div className="errorContent">
              <img
                alt=""
                className="errorClose"
                src={errorCloseImg}
                onClick={() => this.props.errorClose()}
              />
              <div className="title fontBold colorGrey1">
                {this.props.step.errorTitle}
              </div>
              <div className="texte fontBook colorGrey1">
                {this.props.step.errorMessage}
              </div>
              <button
                className="cta fontBold"
                onClick={() => this.props.errorClose()}
              >
                Continuer
              </button>
            </div>
          </div>
        ) : null}
        {this.props.restIntel.requesting || this.props.lead.requestingLead ? (
          <div className="loader">
            <div className="loaderPicto" />
          </div>
        ) : null}
        <div className="gobaleContent">
          <div className="moduleContent">
              <div className="moduleMain">
              { this.props.step.pageNumber!==6 ? (
                <div
                  className="moduleMainBody"
                  ref="scrollDiv"
                  style={this.props.step.pageNumber === 5 ? lastPage : null}
                >
                  {this.props.inquires.home.type === "achat" ? (
                    <div className="titleTop fontBlack">Vous avez <span>un projet d'achat.</span></div>
                  ) : null}
                  {this.props.inquires.home.type === "demande" ? (
                    <div className="titleTop fontBlack">Vous demandez <span>des informations.</span></div>
                  ) : null}

                  <div className={this.props.step.pageNumber > 0 ? "drop-down done"  : "drop-down" }>
                    {this.props.inquires.home.type === "achat" ? (
                      <div className="pageTitle fontBold"><span className="nb fontRegular">1</span>Votre projet<span className="Select-arrow"></span></div>
                    ) : null}
                    {this.props.inquires.home.type === "demande" ? (
                      <div className="pageTitle fontBold"><span className="nb fontRegular">1</span>Votre demande<span className="Select-arrow"></span></div>
                    ) : null}
                    <div className="pageSep" />
                    <div className={this.props.step.pageNumber === 0 ? "content-drop done"  : "content-drop" }>
                      {this.props.step.pageNumber === 0 ? <PageRequest /> : null}
                    </div>
                  </div>
                  <div className={this.props.step.pageNumber > 1 ? "drop-down done"  : "drop-down" }>
                    <div className="pageTitle fontBold"><span className="nb fontRegular">2</span>Vos informations personnelles<span className="Select-arrow"></span></div>
                    <div className="pageSep" />
                    <div className={this.props.step.pageNumber === 1 ? "content-drop done"  : "content-drop" }>
                      {this.props.step.pageNumber === 1 ? <PageInformation /> : null}
                    </div>
                  </div>
                  <div className={this.props.step.pageNumber > 2 ? "drop-down done"  : "drop-down" }>
                    <div className="pageTitle fontBold"><span className="nb fontRegular">3</span>Choix du véhicule<span className="Select-arrow"></span></div>
                    <div className="pageSep" />
                    <div className={this.props.step.pageNumber === 2 ? "content-drop done"  : "content-drop" }>
                      {this.props.step.pageNumber === 2 ? <PageCar /> : null}
                    </div>
                  </div>
                  <div className={this.props.step.pageNumber > 3 ? "drop-down done"  : "drop-down" }>
                    <div className="pageTitle fontBold"><span className="nb fontRegular">4</span>Choix du distributeur<span className="Select-arrow"></span></div>
                    <div className="pageSep" />
                    <div className={this.props.step.pageNumber === 3 ? "content-drop done"  : "content-drop" }>
                      {this.props.step.pageNumber === 3 ? <PageDealer /> : null}
                    </div>
                  </div>
                  <div className={this.props.step.pageNumber > 4 ? "drop-down done"  : "drop-down" }>
                    <div className="pageTitle fontBold"><span className="nb fontRegular">5</span>Choix du rendez-vous<span className="Select-arrow"></span></div>
                    <div className="pageSep" />
                    <div className={this.props.step.pageNumber === 4 ? "content-drop done"  : "content-drop" }>
                      {this.props.step.pageNumber === 4 ? <PageCalendar /> : null}
                    </div>
                  </div>
                  <div className={this.props.step.pageNumber > 5 ? "drop-down done"  : "drop-down" }>
                    <div className="pageTitle fontBold"><span className="nb fontRegular">6</span>Votre rendez-vous<span className="Select-arrow"></span></div>
                    <div className="pageSep" />
                    <div className={this.props.step.pageNumber === 5 ? "content-drop done"  : "content-drop" }>
                      {this.props.step.pageNumber === 5 ? <PageAppointment /> : null}

                    </div>
                  </div>
                  <div className="mentions">
                    <div className="pageSep" />
                    <div className="txt-content">
                    <h3>Protection des données :</h3>
                    <p>Le responsable du traitement des données personnelles est SEAT France, Division de Volkswagen Group France. Ces informations font l’objet d’un traitement automatisé, elles sont nécessaires pour répondre à votre demande de rendez-vous et pourront être transmises à Volkswagen Group France, ses filiales, son réseau de distributeurs et réparateurs agréé SEAT France et toute société du groupe Volkswagen AG. Ces informations ne seront pas transmises hors du territoire de l’Union Européenne et ne seront pas conservées au-delà de 3 ans à compter du dernier contact actif de votre part ; en l’absence de ces informations ou si vous exerciez votre droit d’opposition avant la prestation, nous ne pourrons vous fournir cette prestation. Ces informations nous permettent également – si vous avez donné votre accord (que vous pouvez retirer à tout moment) - de mieux vous connaître, de répondre à vos besoins et de vous dispenser un service de qualité ainsi que de vous contacter dans le cadre d’opérations commerciales et marketing.</p>
                    <p>Conformément au règlement n° 2016/679, dit règlement général sur la protection des données (RGPD), vous disposez d'un droit d’accès, de rectification, d’opposition, de limitation, de suppression et de portabilité des informations vous concernant. Vous pouvez exercer ces droits en écrivant au Délégué à la protection des données de Volkswagen Group France à l’adresse email suivante :<a href="mailto:donneespersonnelles@volkswagengroup.fr">donneespersonnelles@volkswagengroup.fr</a>, ou à l’adresse postale suivante : Volkswagen Group France Relation Client, 11 Avenue de Boursonne, 02600 Villers-Cotterêts, accompagné d’une copie d’un titre d’identité. Vous disposez également du droit d’introduire une réclamation auprès d’une autorité de contrôle, à savoir la Commission Nationale Informatique et Liberté (CNIL) en France.</p>
                    <p>Concernant la newsletter de SEAT France, vous pourrez comme la loi vous y autorise mettre fin à votre abonnement à tout moment depuis le lien mis à votre disposition dans chacune des communications qui vous seront envoyées. Conformément aux articles L121-34 et ss du code de la consommation, si vous ne souhaitez plus être démarché par téléphone, vous pouvez inscrire à tout moment votre numéro de téléphone, que vous avez accepté de nous communiquer, sur la liste d’opposition au démarchage téléphonique par Internet <a href="http://www.bloctel.gouv.fr/" target="_blank">www.bloctel.gouv.fr</a> ou par courrier en écrivant à : Société Opposetel, Service Bloctel, 6 rue Nicolas Siret 10000 Troyes. Cette inscription est gratuite et valable trois ans mais, pour répondre à votre demande, nous pourrons vous contacter pendant un délai de 3 mois à compter de la date de la demande.</p>
                    </div>
                  </div>

                </div>
                ) : (
                  <div
                  className="moduleMainBody"
                  ref="scrollDiv"
                  style={this.props.step.pageNumber === 5 ? lastPage : null}
                >
                  <PageMap />
                  </div>
                )}
              </div>

            {/* <Ariane /> */}

          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  ...state
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      scrollChange,
      mobileCheck,
      stepDirect,
      errorClose
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Module);



// WEBPACK FOOTER //
// ./src/containers/module.js